import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import ProfileTabs from '../components/profileComponents/ProfileTabs';
import Orders from '../components/profileComponents/Orders';
import moment from 'moment';
import 'moment/locale/es';
import { getOrders, getPreorders } from '../service/OrdersService';
import Preorders from '../components/profileComponents/Preorders';
import Loading from '../components/LoadingError/Loading';

const ProfileScreen = ({ user }) => {
  const [orders, setOrders] = useState();
  const [preorders, setPreorders] = useState();
  const [loading, setLoading] = useState(true);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [loadingPreorders, setLoadingPreorders] = useState(true);
  const [ordersError, setOrdersError] = useState();
  const [preordersError, setPreordersError] = useState();

  moment.locale('es');

  useEffect(() => {
    if (user) {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (!loading) {
      getOrders()
        .then((orders) => {
          const inverseArray = [];
          orders.map((order) => inverseArray.unshift(order));
          setOrders(inverseArray);
        })
        .catch((e) => setOrdersError(e));

      getPreorders()
        .then((preorders) => {
          const inverseArray = [];
          preorders.map((preorder) => inverseArray.unshift(preorder));
          setPreorders(inverseArray);
        })
        .catch((e) => setPreordersError(e));
    }
  }, [loading]);

  useEffect(() => {
    if (orders) {
      setLoadingOrders(false);
    }
    if (preorders) {
      setLoadingPreorders(false);
    }
  }, [orders, preorders]);

  return (
    <>
      <Header searcherDisabled={true} shopLink={true} />
      {loading ? (
        <Loading />
      ) : (
        <div className='container mt-lg-5 mt-3' style={{ minHeight: 'calc(100vh - 185px)' }}>
          <div className='row align-items-start'>
            <div className='col-lg-4 p-0 shadow '>
              <div className='author-card pb-0 pb-md-3'>
                <div className='author-card-cover'></div>
                <div className='author-card-profile row'>
                  <div className='author-card-avatar col-md-5'>
                    <img src='./images/user.png' alt='userprofileimage' />
                  </div>
                  <div className='author-card-details col-md-7'>
                    <h5 className='author-card-name mb-2'>
                      <strong>{user?.name}</strong>
                    </h5>
                    <span className='author-card-position'>
                      <>Se unió en {moment(user?.createdAt).format('LL')}</>
                    </span>
                  </div>
                </div>
              </div>
              <div className='wizard pt-3 '>
                <div className='d-flex align-items-start'>
                  <div
                    className='nav align-items-start flex-column col-12 nav-pills me-3 '
                    id='v-pills-tab'
                    role='tablist'
                    aria-orientation='vertical'
                  >
                    <button
                      className='nav-link active'
                      id='v-pills-home-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#v-pills-home'
                      type='button'
                      role='tab'
                      aria-controls='v-pills-home'
                      aria-selected='true'
                    >
                      Ajustes del perfil
                    </button>
                    <button
                      className='nav-link d-flex justify-content-between'
                      id='v-pills-profile-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#v-pills-profile'
                      type='button'
                      role='tab'
                      aria-controls='v-pills-profile'
                      aria-selected='false'
                    >
                      Lista de pedidos sin completar
                      <span className='badge2'>
                        {preorders ? preorders.length : 0}
                      </span>
                    </button>
                    <button
                      className='nav-link d-flex justify-content-between'
                      id='v-pills-order-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#v-pills-order'
                      type='button'
                      role='tab'
                      aria-controls='v-pills-order'
                      aria-selected='false'
                    >
                      Lista de pedidos
                      <span className='badge2'>
                        {orders ? orders.length : 0}
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* panels */}
            <div
              className='tab-content col-lg-8 pb-5 pt-lg-0 pt-3'
              id='v-pills-tabContent'
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  <div
                    className='tab-pane fade show active'
                    id='v-pills-home'
                    role='tabpanel'
                    aria-labelledby='v-pills-home-tab'
                  >
                    <ProfileTabs user={user} />
                  </div>
                  <div
                    className='tab-pane fade'
                    id='v-pills-profile'
                    role='tabpanel'
                    aria-labelledby='v-pills-profile-tab'
                  >
                    <Preorders
                      preorders={preorders}
                      loadingPreorders={loadingPreorders}
                      preordersError={preordersError}
                    />
                  </div>
                  <div
                    className='tab-pane fade'
                    id='v-pills-order'
                    role='tabpanel'
                    aria-labelledby='v-pills-order-tab'
                  >
                    <Orders
                      orders={orders}
                      loadingOrders={loadingOrders}
                      ordersError={ordersError}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileScreen;
